import styles from './styles/index.css' assert { type: 'css' }
import { pageHome, pageOurPlatform } from './pages'
import { handleNewsletterSubscription, NavMenu, registerAnimations } from './utils'

window.Webflow ||= []
window.Webflow.push(() => {
  new NavMenu()
  registerAnimations()
  handleNewsletterSubscription()

  const pages = {
    home: '/',
    platform: '/our-platform',
    healthPlans: '/who-we-help/health-plans',
    digitalHealth: '/who-we-help/digital-health',
  }

  switch (window.location.pathname) {
    case pages.home:
      pageHome()
      break
    case pages.platform:
      pageOurPlatform()
      break
    default:
      break
  }
})
